import axios from "../../axios/index.js";

export default {
    fetchShift(id) {
        return axios.get(`/shift/${id}`);
    },
    fetchShifts() {
        return axios.get("/shift/");
    },
    addShift(payload) {
        return axios.post("/shift/add", payload);
    },
    editShift(payload) {
        return axios.put(`/shift/${payload.Id}`, payload);
    },
    deleteShift(id) {
        return axios.delete(`/shift/${id}`);
    }
}